// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f49b922e","455":"fe6d4823","977":"cb736d04"}[chunkId] + ".chunk.js";
};